import { Component, Vue } from 'vue-property-decorator'

@Component
export default class NursingBranch extends Vue {
  protected get isNursingBranch() {
    return Vue.prototype.$cookies.get('dataGdls')?.academyCode?.toLowerCase() === 'kango'
  }
}
